import type { ReactElement } from 'react';
import styles from './LeadCaptureSuccess.module.css';

export interface LeadCaptureSuccessProps {
  /** `null` quando o participante recusou o consentimento (HUB-201) — a
   * ativação prossegue normalmente, sem que nenhum lead tenha sido criado. */
  leadName: string | null;
  onCaptureAnother: () => void;
}

function buildConfirmationMessage(leadName: string | null): string {
  if (leadName) return `Lead de ${leadName} capturado com sucesso!`;
  return 'Participação confirmada — nenhum dado pessoal foi coletado.';
}

/** Tela de confirmação exibida ao fim da captura de lead fictícia
 * (HUB-147, CA-2), cobrindo tanto o lead criado quanto a recusa de
 * consentimento (HUB-201). */
export function LeadCaptureSuccess({
  leadName,
  onCaptureAnother,
}: LeadCaptureSuccessProps): ReactElement {
  return (
    <section className={styles.container} aria-label="Lead capturado">
      <div className={styles.card}>
        <p className={styles.icon} aria-hidden="true">
          ✓
        </p>
        <p className={styles.message} role="status" aria-live="polite">
          {buildConfirmationMessage(leadName)}
        </p>
        <button type="button" className={styles.button} onClick={onCaptureAnother}>
          Capturar outro lead
        </button>
      </div>
    </section>
  );
}
